var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiBadgeFilledWhite = function SvgAiBadgeFilledWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 23"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.527,
    height: 21.03,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 10.515
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 51.527,
    height: 21.03,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 10.515
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M24.035 6.77v8.49H22.06V6.77zM13.244 6.77h2.235l4.22 8.49h-2.14l-.898-1.821h-4.658l-.899 1.82H9zm1.1 1.94-1.537 3.097h3.062zM37.759 11.414c.385.22.385.834 0 1.053a9.7 9.7 0 0 0-3.577 3.53c-.22.38-.823.38-1.044 0a9.7 9.7 0 0 0-3.577-3.53c-.385-.22-.385-.834 0-1.053a9.7 9.7 0 0 0 3.577-3.53c.221-.38.823-.38 1.044 0a9.7 9.7 0 0 0 3.577 3.53M42.5 6.711c.35.274.35.931 0 1.204q-.407.32-.728.722c-.273.343-.915.343-1.188 0a4.4 4.4 0 0 0-.729-.722c-.35-.273-.35-.93 0-1.204q.407-.319.729-.722c.273-.342.915-.342 1.188 0q.321.403.729.722"
  })));
};
export default SvgAiBadgeFilledWhite;